<template>
  <div class="message">
    <h1>{{ title }}</h1>
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.message {
  padding: 0 20px;
}
</style>
